import React, { useEffect, useState } from 'react';
import './App.css';
import axios from 'axios';
import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CreativeLogin from './components/CreativeLogin';
import CreativeDashboard from './components/CreativeDashboard';
import LetThereBeAI from './components/LetThereBeAI';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [triggerCalendarModal, setTriggerCalendarModal] = React.useState(false);

  const handleHireUsClick = () => {
    // Scroll to hero section first
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Trigger calendar modal after a short delay
    setTimeout(() => {
      setTriggerCalendarModal(true);
      setTimeout(() => setTriggerCalendarModal(false), 100);
    }, 300);
  };

  return (
    <>
      <Navbar onHireUsClick={handleHireUsClick} />
      <HeroSection openCalendarModal={triggerCalendarModal} />
      <AboutSection />
      <ServicesSection />
      <PortfolioSection />
      <ContactSection />
      <Footer />
    </>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const testConnection = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    testConnection();

    // Check if user is already logged in
    const token = localStorage.getItem('creative_token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/let-there-be-ai" element={<LetThereBeAI />} />
        <Route 
          path="/creative-login" 
          element={<CreativeLogin onLogin={() => setIsAuthenticated(true)} />} 
        />
        <Route 
          path="/creative-dashboard" 
          element={<CreativeDashboard />} 
        />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;